import { useNavigate, useLocation } from 'react-router-dom';
import React, { ReactNode } from "react";
import { Button } from "react-bootstrap";
import COLORS from "../../Helpers/utils";

interface ButtonWithIconProps {
    children: ReactNode;
    path: string;
    imagePath: string;
    style?: React.CSSProperties;
}

const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
                                                           children,
                                                           path,
                                                           imagePath,
                                                           style = {}
                                                       }) => {
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <Button
            style={{
                width: '100%',
                backgroundColor: COLORS.primary,
                fontSize: '10pt',
                borderColor: COLORS.primary,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: '8px 12px',
                marginBottom: '10px',
                ...style
            }}
            onClick={() => navigate(`${location.pathname}${path}`)}
        >
            <span>{children}</span>
            <img src={imagePath}
                 style={{
                     width: '26px',
                     height: '26px',
                     filter: 'brightness(0) invert(1)',
            }}
            />
        </Button>
    );
};

export default ButtonWithIcon;